"use client";

import { useEffect } from "react";
import { LanguageProvider, useLanguage } from "@/lib/useLanguage";
import { getSupabaseBrowserClient } from "@/lib/supabase-browser";

export function PreferredLanguageSync() {
  const { language } = useLanguage();

  useEffect(() => {
    const supabase = getSupabaseBrowserClient();
    if (!supabase) return;
    void (async () => {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) return;
      await supabase
        .from("users")
        .update({
          preferred_language: language,
          updated_at: new Date().toISOString(),
        })
        .eq("id", user.id);
    })();
  }, [language]);

  return null;
}

export function LanguageProviderWrapper({
  children,
}: {
  children: any;
}) {
  return (
    <LanguageProvider>
      <PreferredLanguageSync />
      {children}
    </LanguageProvider>
  );
}

